function LandingHeader() {
  return (
    <>
      {/* <header className='text-gray-600 body-font bg-white w-full'>
        <div className='flex justify-end items-center p-5'>
          <div className='w-20'>
            <Link to='/'>
              <img src='https://assets.seinterminal.com/images/logos/STP_Logo_Color.png' alt='Sage Logo' />
            </Link>
          </div>
        </div>
      </header> */}

      <div className='flex justify-center bg-white'>
        <div className='w-64 mt-16'>
          <img src='https://assets.seinterminal.com/images/logos/SEIN_Terminal_Logo_Color.png' alt='Sage Logo' />
        </div>
      </div>
    </>
  );
}

export default LandingHeader;
